/* eslint-disable import/prefer-default-export */
import AccuCheck from '../../../../assets/images/accu-chek.jpg';
import AccuCheckBase from '../../../../assets/images/accu-chekBase.jpg';
import DrVaidyaImg from '../../../../assets/images/dr-vaidyas.jpg';
import DrVaidyaBase from '../../../../assets/images/dr-vaidyasBase.jpg';
import HealthVitImg from '../../../../assets/images/healthvit.jpg';
import HealthVitBase from '../../../../assets/images/healthvitBase.jpg';
import Pro360Image from '../../../../assets/images/pro360.jpg';
import ProBase from '../../../../assets/images/pro360Base.jpg';

export const brandsData = [
  {
    name: 'AccuCheck',
    image: AccuCheck,
    baseImage: AccuCheckBase,
    offerMsg: 'Up To 25% Off',
  },
  {
    name: 'DrVaidya',
    image: DrVaidyaImg,
    baseImage: DrVaidyaBase,
    offerMsg: 'Up To 63% Off',
  },
  {
    name: 'HealthVit',
    image: HealthVitImg,
    baseImage: HealthVitBase,
    offerMsg: 'Up To 35% Off',
  },
  {
    name: 'Pro360',
    image: Pro360Image,
    baseImage: ProBase,
    offerMsg: 'Up To 25% Off',
  },
];
